import React from 'react';
import babyCare from '../../../Assert/babycare.png'
import SectionHeading from '../../../Components/Shared/SectionHeading';

const ProductCategories = () => {
    return (
        <div className='mb-14 mx-2'>

            <SectionHeading text={"Find your items from wide range of product categories"} />
            <div className="grid md:grid-cols-6 grid-cols-2 gap-4 my-4" >
                {Array.from({ length: 12 }).map((_, id) => <div key={id} className='shadow-lg hover:shadow-4xl hover:bg-gray-300 flex flex-col p-2 py-4 ease-in-out duration-300 justify-center items-center rounded-md'>
                    <div className=""><img src={babyCare} className='w-14 h-14' alt="" /></div>
                    <span className='text-xs'>Baby Care</span>
                </div>)}
            </div>
        </div>
    );
};

export default ProductCategories;